/**
 * People Also Bought — add/remove toggle using Shopify AJAX Cart API.
 * Clicking "Add" adds the variant to the cart and switches the button
 * into an "Added" (checked) state. Clicking it again removes that line
 * item from the cart, like a checkbox.
 */
(function () {
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function getContainer() {
    return document.querySelector('[data-people-also-bought]');
  }

  function setButtonState(button, { added, loading }) {
    if (typeof loading === 'boolean') {
      button.classList.toggle('is-loading', loading);
    }
    if (typeof added === 'boolean') {
      button.setAttribute('aria-pressed', added ? 'true' : 'false');
      const label = button.querySelector('[data-pab-label], .people-also-bought__add-text');
      if (label) {
        label.textContent = added
          ? (button.dataset.addedText || 'Added')
          : (button.dataset.addText || 'Add');
      }
    }
  }

  async function addToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    setButtonState(button, { loading: true });

    try {
      const response = await fetch(`${ROOT}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error((errorData && errorData.message) || 'Could not add item to cart');
      }

      const data = await response.json();
      const lineItem = Array.isArray(data.items) ? data.items[0] : data;

      button.dataset.lineItemKey = lineItem.key;
      setButtonState(button, { added: true, loading: false });

      document.dispatchEvent(
        new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'people-also-bought' } })
      );
    } catch (error) {
      console.error('[people-also-bought] add failed:', error);
      setButtonState(button, { added: false, loading: false });
    }
  }

  async function removeFromCart(button) {
    const lineItemKey = button.dataset.lineItemKey;
    if (!lineItemKey) {
      // Nothing to remove, just reset the UI.
      setButtonState(button, { added: false, loading: false });
      return;
    }

    setButtonState(button, { loading: true });

    try {
      const response = await fetch(`${ROOT}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: lineItemKey, quantity: 0 }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error((errorData && errorData.message) || 'Could not remove item from cart');
      }

      delete button.dataset.lineItemKey;
      setButtonState(button, { added: false, loading: false });

      document.dispatchEvent(
        new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'people-also-bought' } })
      );
    } catch (error) {
      console.error('[people-also-bought] remove failed:', error);
      setButtonState(button, { added: true, loading: false });
    }
  }

  function handleClick(event) {
    const button = event.target.closest('[data-pab-add-btn]');
    if (!button || button.disabled || button.classList.contains('is-loading')) return;

    event.preventDefault();

    const isAdded = button.getAttribute('aria-pressed') === 'true';
    if (isAdded) {
      removeFromCart(button);
    } else {
      addToCart(button);
    }
  }

  function init() {
    const container = getContainer();
    if (!container) return;
    container.addEventListener('click', handleClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();